const initState = {
    mapOverlayOptions: [],
    activeMapOverlayId: 0
};

export default initState;
